import './assets/style.css';
import './assets/normalize.css';


import Vue from 'vue';
import App from './App.vue';
import Adder from './add.js';




var vm = new Vue({
  el: '#app',
  render: h => h(App)
})

global.vm = vm;


// WEBPACK FOOTER //
// ./process/main.js